<emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'item_groupings_search_bar'"
        [displaySearchWithOptions]="false"
        [fields]="fields"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        layout-center-header
        (add)="openCreateItemGroupingForm()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-tree
        [contextMenuActions]="itemGroupingsContextMenuActions"
        [disableContextActions]="centerLoading$ | async"
        [disableDefaultOnMove]="true"
        [items]="nodes$ | async"
        layout-center-content
        [options]="options"
        [readonly]="isReadOnly$ | async"
    ></emm-generic-items-tree>
    <emm-management-attributes-header
        *ngIf="!addClicked && (itemDetail$ | async) as item"
        layout-right-header
        [name]="item.name"
        [tag]="item.tag"
        [type]="item.itemType"
    ></emm-management-attributes-header>
    <emm-items-form *ngIf="!addClicked && (itemDetail$ | async) as item"
        #form
        layout-right-content
        [selectedItem]="item"
    ></emm-items-form>
    <emm-management-attributes-header
        *ngIf="addClicked"
        layout-right-header
        [name]="'New Item Grouping'"
        [tag]="'TBD'"
        [type]="'TBD'"
    ></emm-management-attributes-header>
    <emm-item-creation-form *ngIf="addClicked"
                            #form
                            layout-right-content
                            [attributes]="globalAttributes"
                            [previousAttributeGroups]="previousAttributeGroups$ | async"
                            (attributeGroupSelected)="onAttributeGroupSelected($event)"
                            (cancelClicked)="addClicked = false"
                            (submissionFinished)="onCreateFinished()"
    ></emm-item-creation-form>
</emm-management-layout>
